// extracted by mini-css-extract-plugin
module.exports = {"pendingColor":"#2e76bf","processingColor":"#dbaf21","canceledColor":"#666","successfulColor":"#398422","rejectColor":"#bf4646"};